/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_ImageInputs */



/**
* | output |
* | --- |
* | "Bulk carrier at anchor off a wooded coast" |
*
* @param {Home_Hero_ImageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_hero_image = /** @type {((inputs?: Home_Hero_ImageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_ImageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("锚泊在林木葱郁海岸外的散货船")
	return /** @type {LocalizedString} */ ("Bulk carrier at anchor off a wooded coast")
});